import { supabase } from './supabase';

/**
 * Auth header for direct calls to the ONVIF gateway.
 *
 * The access token is cached from onAuthStateChange instead of calling
 * supabase.auth.getSession() per request, so gateway calls never compete for
 * the auth-token lock (see docs/SUPABASE_AUTH_LOCK_DEADLOCK.md).
 */
let accessToken: string | null = null;

supabase.auth.onAuthStateChange((_event, session) => {
  accessToken = session?.access_token ?? null;
});

export function gatewayAuthHeaders(): Record<string, string> {
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
}
